@for (data of dataProfile; track data) {
  <div class="container"  style="min-height: 125vh;" >
    <div style="justify-content:center;">
      <div style="display: flex; flex-direction:column; align-items: center;">
        <div style="display: flex;">
          <h2 style="text-transform: capitalize; text-shadow: 3px 3px 5px white;">{{data.name}}</h2>
          <div style="margin-left: 50px;">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button (click)='modalEdit("perfil")' mat-menu-item>
                <mat-icon>edit</mat-icon>
                <span>Editar Perfil</span>
              </button>
              <button mat-menu-item (click)='modalEdit("contrasena")'>
                <mat-icon>vpn_key</mat-icon>
                <span>Cambiar contraseña</span>
              </button>
              <button mat-menu-item (click)='modalEdit("foto")'>
                <mat-icon>add_a_photo</mat-icon>
                <span>Editar foto</span>
              </button>
              <!-- <button mat-menu-item [matMenuTriggerFor]="Temas">
              <mat-icon>format_paint</mat-icon>
              <span>Tema</span>
            </button> -->
          </mat-menu>
          <!-- <mat-menu #Temas="matMenu">
          <button mat-menu-item>dark</button>
          <button mat-menu-item>light</button>
        </mat-menu> -->
      </div>
    </div>
    <img class="mat-elevation-z8" src="{{userPicture}}" [ngStyle]="sizePicture">
  </div>
</div>
<div style="text-transform: capitalize;">
  <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z1">
    <mat-tab label="Información Personal">
      <mat-list>
        <mat-list-item>
          <span matListItemTitle>Nombre</span>
          {{ data.name }}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <span matListItemTitle>Usuario</span>
          {{ data.user }}
        </mat-list-item>
        <mat-divider></mat-divider>
        @if (data.phone>0) {
          <mat-list-item>
            <span matListItemTitle>Telefono</span>
            {{ data.phone }}
          </mat-list-item>
        }
        <mat-divider>*ngIf="data.phone> 0"></mat-divider>
        @if (data.email!='') {
          <mat-list-item>
            <span matListItemTitle>Correo</span>
            {{ data.email }}
          </mat-list-item>
        }
        <mat-divider> *ngIf="data.email!=''"></mat-divider>
        <mat-list-item>
          <span matListItemTitle>Ciudad</span>
          {{ data.cityName }}
        </mat-list-item>
        <mat-divider></mat-divider>
        @if (data.address!='') {
          <mat-list-item>
            <span matListItemTitle>Direccion</span>
            {{ data.address }}
          </mat-list-item>
        }
        <mat-divider> *ngIf="data.address!''"></mat-divider>
        <mat-list-item>
          <span matListItemTitle>Fecha Ingreso</span>
          {{ fechaIngreso }}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <span matListItemTitle>Antigüedad</span>
          {{ antiguedad }}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <!-- <span matListItemTitle>cv</span> -->

          <button matListItemTitle (click)='openCV()' style='background: transparent; border: 0;' matTooltip='Abrir hoja de vida'>
            <mat-icon>assignment_ind</mat-icon>
          </button>

        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
    </mat-tab>
    <mat-tab label="Información adicional">
      <mat-list>
        <mat-list-item>
          <span matListItemTitle>Area</span>
          {{ data.areaName }}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <span matListItemTitle>Cargo</span>
          {{ data.jobTitleName }}
        </mat-list-item>
        <mat-divider></mat-divider>
        @if (data.emergencyContact!='') {
          <mat-list-item>
            <span matListItemTitle>Contacto de emergencia</span>
            {{ data.emergencyContact }}
          </mat-list-item>
        }
        <mat-divider>*ngIf="data.emergencyContact!=''"></mat-divider>
        @if (data.emergencyContactPhone> 0) {
          <mat-list-item>
            <span matListItemTitle>Contacto de emergencia</span>
            {{ data.emergencyContactPhone }}
          </mat-list-item>
        }
        <mat-divider> *ngIf="data.emergencyContactPhone> 0"</mat-divider>
        <mat-list-item>
          <span matListItemTitle>EPS</span>
          {{ data.epsName }}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <span matListItemTitle>ARL</span>
          {{ data.arlName }}
        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
    </mat-tab>
  </mat-tab-group>
</div>
</div>
}
